/**
 * 重构后的后台返回错误码(用于和之前php的错误码字典文件key冲突)
 */
export default {
  TAG_ALREADY_EXITS: 103, // 标签已存在
  TOKEN_NOT_ACCEPTABLE: 105, // token失效
  NO_PERMISSION_OPERATION: 109, // 没有权限操作
  EDM_TASK_NOT_FOUND: 1599, // 找不到对应的邮件信息
  USER_PERMISSION_DENIED: 109, // 没有权限查看权限（暂时只用于edm）
  CARD_ACCESS_DENINED: 112, // 没有权限访问该名片
  TASK_HAS_BEEN_DELETED: 113, // 任务已被删除
  DUPLICATE_KEYWORD_ERROR: 120, // 重复关键字添加
  EDM_CFM_MAX_EMAIL: 121, // 邮件收件人达最高5000以上
  UID_NOT_IN_COMPANY: 280, // 账号或uid不在公司内
  NO_AVAILABLE_PRODUCT: 401, // 没有可用的商品
  NO_HIGHER_LEVEL_PRODUCT: 503, // 没有更高级的套餐
  ITEMS_DUPLICATE: 1050, // xx已存在
  EDM_NO_LIMIT: 1060, // 当前发送邮件的额度为0
  EDM_BEYOND_LIMIT_COUNT: 1061, // 要发送的邮件数超出限额
  UPLOAD_CONTENT_SIZE_LIMIT: 1062, // 上传图片/文件大小
  UPLOAD_ERROR: 1063, // 上传发生错误
  UPLOAD_SERVER_ERROR: 1064, // 服务器错误（暂时只用于上传edm中正文的图片上传）
  UPLOAD_IMAGE_ILLEGAL: 1065, // 图片不合规
  CLOUD_CHECK_CHARGE_ERROR: 513, // 精准识别 扣费错误
  CLOUD_CHECK_CARD_OR_IMG_NOT_EXIST: 304, // 精准识别 名片不存在或者图片不存在
  CLOUD_CHECK_DPS_ERROR: 1596, // DPS提交错误
  TAG: {
    // TAG 操作模块
    103: 'tagname_exist',
    105: 'err_nopermit',
    109: 'err_nopermit',
    621: 'tagname_exist'
  },
  BATCH_UPDATE_ERROR: {
    3201: 'err_device_illegal', // 导入设备类型不合法
    3202: 'err_info_less', // 缺少必填信息：姓名/员工ID/初始密码
    3203: 'err_info_bad_format', // 错误的格式：员工ID/初始密码
    3204: 'payment_error_uid', // 账号无法找到
    3205: 'err_account_illegal', // 创建者账号不存在
    3206: 'excel_user_error', //  Excel导入, 单张上传错误
    3207: 'err_user_existed', // 该员工ID已经加入企业帐户
    3208: 'err_ip_exceed_limit', // 可以导入的员工数已用完
    3209: 'err_export_excel', // 导出Excel权限设置失败，填入信息不合法
    3210: 'err_save_personal', // 存入私人名片夹设置失败，填入信息不合法
    3211: 'err_superior_illegal', // 设置上司失败，上司帐户不合法
    3212: 'err_fast_track', // 精准识别张数设置失败，填入信息不合法
    3213: 'err_account' // 创建用户失败，填入的账号是无效的
  },
  GOOGLE_CONTACT_ERROR: {
    1101: 'google_contact_auth_outdate', // 授权失败
    1102: 'google_contact_no_sync_data', // 没有要同步的联系人
    1103: 'google_contact_syncing' // 有名片正在同步中
  },
  OUTLOOK_CONTACT_ERROR: {
    1101: 'outlook_contact_auth_outdate', // 授权失败
    1102: 'outlook_contact_no_sync_data', // 没有要同步的联系人
    1103: 'outlook_contact_syncing' // 有名片正在同步中
  }
}
